import { render, staticRenderFns } from "./LegSelector.vue?vue&type=template&id=3ee924d2&scoped=true"
import script from "./LegSelector.vue?vue&type=script&lang=js"
export * from "./LegSelector.vue?vue&type=script&lang=js"
import style0 from "./LegSelector.vue?vue&type=style&index=0&id=3ee924d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee924d2",
  null
  
)

export default component.exports